import { DOC_FLOW_PHASE_TITLE_KEYS } from '../../constants/docFlow'
import { PhaseItemStatus } from '../Entity'

import {
  DOC_FLOW_PHASE_INFO_NOTIFICATION_COMBINING,
  DOC_FLOW_PHASE_INFO_NOTIFICATION_RESULT,
  DOC_FLOW_PHASE_INFO_NOTIFICATION_SPLITTING,
  DOC_FLOW_PHASE_INFO_NOTIFICATION_UPLOADING,
  DOC_FLOW_PHASE_INFO_NOTIFICATIONS_SENDING,
  DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING,
  DocFlowPhaseItemStatus,
} from './DocFlow.constants'
import { DocFlowCombining } from './DocFlowCombining'
import { DocFlowMapping } from './DocFlowMapping'
import { DocFlowPhaseNotSupported } from './DocFlowPhaseNotSupported'
import { DocFlowResult } from './DocFlowResult'
import { DocFlowSending } from './DocFlowSending'
import { DocFlowUploading } from './DocFlowUploading'

export function getPhaseContent(id) {
  switch (id) {
    case DocFlowPhaseItemStatus.Uploading:
      return <DocFlowUploading />

    case DocFlowPhaseItemStatus.Splitting:
      return <DocFlowMapping />

    case DocFlowPhaseItemStatus.Combining:
      return <DocFlowCombining />

    case DocFlowPhaseItemStatus.Sending:
      return <DocFlowSending />

    case DocFlowPhaseItemStatus.Result:
      return <DocFlowResult />

    // An unknown backend phase (a newly added one) must not leave the page blank.
    default:
      return <DocFlowPhaseNotSupported />
  }
}

export function getDocFlowPhases(t) {
  return [
    {
      id: DocFlowPhaseItemStatus.Uploading,
      name: t(DOC_FLOW_PHASE_TITLE_KEYS[DocFlowPhaseItemStatus.Uploading]),
      status: PhaseItemStatus.finished,
    },
    {
      id: DocFlowPhaseItemStatus.Splitting,
      name: t(DOC_FLOW_PHASE_TITLE_KEYS[DocFlowPhaseItemStatus.Splitting]),
      status: PhaseItemStatus.inProgress,
    },
    {
      id: DocFlowPhaseItemStatus.Combining,
      name: t(DOC_FLOW_PHASE_TITLE_KEYS[DocFlowPhaseItemStatus.Combining]),
      status: PhaseItemStatus.notStarted,
    },
    {
      id: DocFlowPhaseItemStatus.Sending,
      name: t(DOC_FLOW_PHASE_TITLE_KEYS[DocFlowPhaseItemStatus.Sending]),
      status: PhaseItemStatus.notStarted,
    },
    {
      id: DocFlowPhaseItemStatus.Result,
      name: t(DOC_FLOW_PHASE_TITLE_KEYS[DocFlowPhaseItemStatus.Result]),
      status: PhaseItemStatus.notStarted,
    },
  ]
}

export function getPhaseNotifications(phase) {
  const notifications = []

  switch (phase) {
    case DocFlowPhaseItemStatus.Uploading:
      notifications.push(
        DOC_FLOW_PHASE_INFO_NOTIFICATION_UPLOADING,
        DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING
      )
      break

    case DocFlowPhaseItemStatus.Splitting:
      notifications.push(DOC_FLOW_PHASE_INFO_NOTIFICATION_SPLITTING)
      break

    case DocFlowPhaseItemStatus.Combining:
      notifications.push(DOC_FLOW_PHASE_INFO_NOTIFICATION_COMBINING)
      break

    case DocFlowPhaseItemStatus.Sending:
      notifications.push(DOC_FLOW_PHASE_INFO_NOTIFICATIONS_SENDING)
      break

    case DocFlowPhaseItemStatus.Result:
      notifications.push(DOC_FLOW_PHASE_INFO_NOTIFICATION_RESULT)
      break

    default:
      break
  }

  return notifications
}

export function isDocFlowPhaseResult(value) {
  return value === DocFlowPhaseItemStatus.Result
}

export function isDocFlowPhaseCombining(value) {
  return value === DocFlowPhaseItemStatus.Combining
}

export function isDocFlowPhaseSplitting(value) {
  return value === DocFlowPhaseItemStatus.Splitting
}
